import {

    FieldValues,
    UseFormRegister
} from 'react-hook-form'
import { NotificationType } from 'types/notification'

interface NeverEventsOrSentinelEventRadioProps {
    notification: NotificationType
    errors: any
    inputClassNames?: string
    register: UseFormRegister<FieldValues>
    readOnly?: boolean
}

export const NeverEventsOrSentinelEventRadio = ({
    register,
    notification,
    errors,
    inputClassNames,
    readOnly
}: NeverEventsOrSentinelEventRadioProps) => {
    return (
        <fieldset className={`relative 'pointer-events-auto`}>
            <legend className="font-semibold text-xs text-darkGray">
            Evento possui Never Events ou Evento Sentinela?
            </legend>
            <div className="flex items-center gap-2">
                <input
                    {...register('u_never_events_or_sentinel_event')}
                    className={`text-yellow ${inputClassNames}`}
                    type="radio"
                    id="no"
                    value="no"
                    readOnly={readOnly}
                    disabled={readOnly}
                    defaultChecked={
                        notification?.u_never_events_or_sentinel_event?.value === 'u_never_events_or_sentinel_event_no'
                    }
                />

                <label className="text-sm" htmlFor="no">
                    Não
                </label>
            </div>

            <div className="flex items-center gap-2">
                <input
                    {...register('u_never_events_or_sentinel_event')}
                    className={`text-yellow ${inputClassNames}`}
                    type="radio"
                    id="yes"
                    value="yes"
                    readOnly={readOnly}
                    disabled={readOnly}
                    defaultChecked={
                        notification?.u_never_events_or_sentinel_event?.value === 'u_never_events_or_sentinel_event_yes'
                    }
                />

                <label className="text-sm" htmlFor="yes">
                    Sim
                </label>
            </div>

            {readOnly && 
            (<input
                type="hidden"
                value={notification?.u_never_events_or_sentinel_event?.value}
                {...register('u_never_events_or_sentinel_event')}
            />)}
          
            {errors && (
                <span className="text-errorText text-xs font-normal absolute">
                    Preenchimento obrigatório
                </span>
            )}
        </fieldset>
    )
}
